/* スクロールアニメーション */
const scrollanime = document.getElementsByClassName('is-anime')
let scrollY;

function animationShow() {
  for (let i = 0; i < scrollanime.length; i++) {
    if (scrollanime[i].getAttribute('class').match(/is-show/) === null) {
      scrollY = window.pageYOffset + window.innerHeight
      clientTop = scrollanime[i].getBoundingClientRect().top + window.pageYOffset

      if (clientTop < scrollY) {
        scrollanime[i].setAttribute('class', scrollanime[i].getAttribute('class') + ' is-show')
      }
    }
  }
}

// 初期で読み込み
animationShow()

//スクロールで要素読み込み
window.addEventListener('scroll', () => {
  animationShow()
})
